import { SubscribedMembershipCard, UnsubscribeConfirmationModal } from '@components';
import { Typography } from 'gd-design-library';
import React, { useState } from 'react';
import { OrderExpanded } from '@services/checkout';
import classnames from 'classnames/bind';
import styles from './Subscriptions.module.scss';
import { Order } from '@commercetools/platform-sdk';

const cx = classnames.bind(styles);

const CN = 'subscriptions';
const titleClassName = `${CN}__title`;

interface SubscriptionsProps {
    subscriptions: OrderExpanded[];
    onUnsubscribe: (orderId: string, lineItemId: string) => Promise<Order | null>
  }

interface ModalPropsType {
  open: boolean,
  lineItemId: string,
  orderId: string,
  features: string[],
  nextPaymentDate?: Date,
}

export const Subscriptions: React.FC<SubscriptionsProps> = ({
  subscriptions,
  onUnsubscribe
}) => {
  const [ modalProps, setModalProps ] = useState<ModalPropsType>({} as ModalPropsType);
  const [ isUnsubscribeLoading, setIsUnsubscribeLoading ] = useState(false);

  const handleUnsubscribe = async (orderId: string, lineItemId: string): Promise<Order | null> => {
    setIsUnsubscribeLoading(true);
    const result = await onUnsubscribe(orderId, lineItemId);
    setIsUnsubscribeLoading(false);
    setModalProps({} as ModalPropsType);

    return result;
  };

  return (
    subscriptions?.length ?
      <div>
        <Typography variant='h6' className={ cx(titleClassName) }> Subscriptions </Typography>
        {subscriptions.map(subscription => (
          subscription.lineItems.map(
            lineItem => {
              const productTypeName = typeof lineItem.productType === 'string'
                ? lineItem.productType
                : lineItem.productType?.name;
              const attrs = lineItem.variant?.attributes ?? [];

              return productTypeName === 'membership' && (
                <SubscribedMembershipCard
                  key={ subscription.id }
                  startDate={ new Date(subscription.createdAt) }
                  duration={ attrs.find((a: { name: string }) => a.name === 'duration')?.value as string }
                  name={ attrs.find((a: { name: string }) => a.name === 'name')?.value as string }
                  features={
                    (attrs.find((a: { name: string }) => a.name === 'features')?.value ?? '').split(',') as string[]
                  }
                  image={ lineItem.variant?.imageUrl ?? '' }
                  handleUnsubscribe={ (): void => setModalProps({
                    open: true,
                    lineItemId: lineItem.id,
                    orderId: subscription.id,
                    features: (attrs.find((a: { name: string }) => a.name === 'features')?.value ?? '').split(',') as string[],
                    nextPaymentDate: subscription.nextPaymentDates?.[lineItem.id]
                  }) }
                />
              );
            }
          )
        ))}
        {modalProps.open &&<UnsubscribeConfirmationModal
          { ...modalProps }
          onUnsubscribe={ handleUnsubscribe }
          handleClose={ (): void => setModalProps({} as ModalPropsType) }
          isLoading={ isUnsubscribeLoading }
        />}
      </div> : null
  );
};

